import { trim } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const trimObjectValues = (obj) =>
  Object.keys(obj).reduce((result, key) => {
    const trimmedValue = trim(obj[key]);
    result[key] = trimmedValue; // eslint-disable-line no-param-reassign

    return result;
  }, {});
